import ManageAudioResourcesController from '../../../../manage-audio-resources/component/controller/ManageAudioResourcesController.js'

export default class CompanyAudioResourcesController extends ManageAudioResourcesController {
  _getAudioResourceService() {
    return this.PS.setupAudioResources(this.company.slug).company
  }
}
